import {
    AllEvents,
    createCollectionAvailableEvent,
    Curation_WithMetadata,
} from '@news-mono/web-common'
import React, { ReactElement } from 'react'
import {
    StyledArticlesArticle,
    StyledArticlesContainer,
    StyledArticlesGrid,
    StyledArticlesHeader,
    StyledArticlesHeaderIcon,
    StyledArticlesHeaderText,
} from './TNArticleCards.styled'
import { LandscapeNightly } from '../../cards/LandscapeNightly/LandscapeNightly'
import { useImpressionAvailable } from '../../__helpers/impression-available-helper'
import { MaybeLoaded } from '@west-australian-newspapers/json-react-layouts-data-loader'
import { useProduct } from '../../__product'

interface TNArticleCardsProps {
    data: MaybeLoaded<Curation_WithMetadata>
    onEvent: (event: AllEvents) => void
    sectionHeading?: string
    displayPublicationDate?: boolean
    renderBasicTeaser?: boolean
    hideBorder?: boolean
    displayKicker?: boolean
    icon?: {
        IconElement: ReactElement
    }
}

export const TNArticleCards = ({
    data,
    onEvent,
    displayPublicationDate,
    renderBasicTeaser,
    hideBorder,
    displayKicker,
    icon,
    sectionHeading
}: TNArticleCardsProps) => {
    const product = useProduct()
    // Fire analytics when viewed.
    const impressionRef = useImpressionAvailable({
        available: () => {
            if (!data.loaded) return
            onEvent(
                createCollectionAvailableEvent(
                    data.result.articles,
                    'Lima',
                    product,
                    onEvent,
                ),
            )
        },
        loading: !data.loaded,
    })

    if (!data.loaded || data.result.articles.length === 0) {
        return null
    }

    const articles = data.result.articles

    return (
        <StyledArticlesContainer>
            {sectionHeading && (
                <StyledArticlesHeader>
                    {icon && icon.IconElement && (
                        <StyledArticlesHeaderIcon>
                            {icon.IconElement}
                        </StyledArticlesHeaderIcon>
                    )}
                    <StyledArticlesHeaderText>
                        {sectionHeading}
                    </StyledArticlesHeaderText>
                </StyledArticlesHeader>
            )}
            <StyledArticlesGrid ref={impressionRef}>
                {articles.map((article, i) => (
                    <StyledArticlesArticle key={article.id}>
                        <LandscapeNightly
                            item={{
                                loaded: true,
                                result: article,
                            }}
                            onEvent={onEvent}
                            cardNumber={i + 1}
                            contentPosition="center"
                            displayNumber={false}
                            imagePosition="left"
                            hideByline={false}
                        />
                    </StyledArticlesArticle>
                ))}
            </StyledArticlesGrid>
        </StyledArticlesContainer>
    )
}
